export const GET_STORE_STATUS = 'GET_STORE_STATUS'
